/**
 * Prefix the portal uses for a membership plan that has no `partner_product` row yet, until the
 * backend swaps it for the persisted partnerProductId on save.
 *
 * Not a uuid on purpose: `partner_product_id` is a uuid column, so a key that escapes the remap is
 * rejected by the database rather than silently persisted.
 */
export const NEW_PLAN_ID_PREFIX = 'new-';
export function isNewPlanId(planId) {
    return planId.startsWith(NEW_PLAN_ID_PREFIX);
}
